import { LogLevel } from '@microsoft/signalr'
import { toUTCDate } from '@/utils/helpers/date-time-helpers'

class LogEntry {
  timestamp: string

  level: LogLevel

  message: string

  exception?: string

  properties?: Record<string, any>

  constructor(logEntry?: any) {
    this.timestamp = toUTCDate(new Date())
    this.level = logEntry.level
    this.message = logEntry.message
    this.exception = logEntry.exception
    this.properties = logEntry.properties
  }
}

export default LogEntry
